import { render, staticRenderFns } from "./MatchBetOutcome.vue?vue&type=template&id=faa6f8a8&scoped=true"
import script from "./MatchBetOutcome.vue?vue&type=script&lang=js"
export * from "./MatchBetOutcome.vue?vue&type=script&lang=js"
import style0 from "./MatchBetOutcome.vue?vue&type=style&index=0&id=faa6f8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa6f8a8",
  null
  
)

export default component.exports